import { Button } from "@/components/ui/button";
import { Settings } from "lucide-react";
import { Link } from "react-router-dom";

const ManageSubscription = () => {
  return (
    <Link to="/pricing">
      <Button variant="outline">
        <Settings className="mr-2 h-4 w-4" />
        Manage Plan
      </Button>
    </Link>
  );
};

export default ManageSubscription;
